import { render, staticRenderFns } from "./insured-info-table.vue?vue&type=template&id=f921216e&scoped=true&"
import script from "./insured-info-table.vue?vue&type=script&lang=js&"
export * from "./insured-info-table.vue?vue&type=script&lang=js&"
import style0 from "./insured-info-table.vue?vue&type=style&index=0&id=f921216e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f921216e",
  null
  
)

export default component.exports